import { useState, useEffect } from "react";
import { Stack, Switch, FormControlLabel } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useRecoilState } from "recoil";
import { useLocation } from "react-router-dom";
import { settingState } from "../../recoil/settingState";
import GuideModal from "../../component/GuideModal";
import GuideTooltip from "./GuideTooltip";

export default function GuideToggle() {
  const theme = useTheme();
  const location = useLocation();
  const [setting, setSetting] = useRecoilState(settingState);
  const [guideModalOpen, setGuideModalOpen] = useState(false);

  // 페이지 로드 시 가이드가 on이면 모달 열기
  useEffect(() => {
    if (setting.guide) {
      setGuideModalOpen(true);
    }
  }, [setting.guide]);

  // 페이지가 바뀔 때마다 가이드 상태 확인
  useEffect(() => {
    if (setting.guide) {
      setGuideModalOpen(true);
    }
  }, [location.pathname, setting.guide]);

  const handleGuideToggle = () => {
    const newGuideState = !setting.guide;
    setSetting((prev) => {
      return { ...prev, guide: newGuideState };
    });

    // 로컬스토리지에 가이드 설정 저장
    try {
      localStorage.setItem(
        "guideSetting",
        JSON.stringify({ guide: newGuideState })
      );
    } catch (error) {
      console.error(
        "로컬스토리지에 가이드 설정을 저장하는데 실패했습니다:",
        error
      );
    }

    // 가이드가 켜지면 모달 열기
    if (newGuideState) {
      setGuideModalOpen(true);
    }
  };

  const handleGuideModalClose = () => {
    setGuideModalOpen(false);
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={2}
      sx={{
        position: "relative",
      }}
    >
      <FormControlLabel
        control={
          <Switch
            checked={setting.guide}
            onChange={handleGuideToggle}
            size="small"
          />
        }
        label="이용 가이드"
        sx={{
          "& .MuiFormControlLabel-label": {
            fontSize: "14px",
            fontWeight: "500",
            color: theme.palette.common.darkGrey,
          },
        }}
      />
      <GuideTooltip />
      <GuideModal open={guideModalOpen} onClose={handleGuideModalClose} />
    </Stack>
  );
}
